<template>
<div
	class="scheduled-item"
	:class="{
		'event-continued' : eventStartToLeft < 0,
		'is-project-tile' : 'type' in item && item.type == 'project',
		'is-service-tile' : 'type' in item && item.type == 'service'
	}"
	v-on:click="$emit('itemClick',item)">
	<i v-if="eventStartToLeft < 0"
		class="fa fa-chevron-left mr-1">
	</i>

	<schedule-card-indicators 
		class="ml-1 mr-1" 
		:event-item="item"
		:selected-date="selectedDate">
	</schedule-card-indicators>

	<slot></slot>

	<schedule-item-tile-fields :item="item" :display-fields="'eventTileDisplayFields' in scheduleSettings && scheduleSettings.eventTileDisplayFields ? scheduleSettings.eventTileDisplayFields : []"></schedule-item-tile-fields>
	<span v-if="item.title"> ({{ item.title }})</span>
</div>
</template>

<script type="text/javascript">
import ScheduleCardIndicators from "./ScheduleCardIndicators"
import ScheduleItemTileFields from "@/components/schedule/ScheduleItemTileFields"

export default {
	name: "ScheduleItem",
	components: {
		ScheduleCardIndicators,
		ScheduleItemTileFields
	},
	props: [
		"scheduleSettings",
		"selectedDate",
		"item"
	],
	computed: {
		eventStartToLeft() {
			return this.dayWidth * this.daysFromStartOfWeek	
		},
		daysFromStartOfWeek() {
			return this.item.startMoment.diff(this.startOfWeekMoment,"days")
		},
		daysDuration() {
			let hrsDuration = this.item.endMoment.diff(this.item.startMoment,"hours")

			return Math.ceil(hrsDuration / 24)
		},
		isAllDay() {
			if (this.item.duration >= 23.98 && this.item.duration <= 24)
				return true

			return false
		},
		backgroundColor() {
			if (this.item.type == 'project')
				return "#7c61f31c"
			else if (this.item.type == 'service')
				return "#61f3af1c"

			return false
		}
	},
	methods: {
		
	}
}
</script>

<style scoped>
.is-project-tile {
	background-color: #7c61f31c !important;
}

.is-service-tile {
	background-color: #61f3af1c  !important;
}
</style>